"use client";

import { useFormContext } from "react-hook-form";
import Input from "../Input";

interface Contact {
  name: string;
  email: string;
}

const NameAndEmail = ({}: {}) => {
  const {
    register,
    formState: { errors },
    getValues,
    watch,
  } = useFormContext<Contact>();

  return (
    <>
      <Input
        name="name"
        label="Name"
        errors={errors}
        register={register}
        rules={{ required: "Required" }}
        testId="name"
      />
      <Input
        name="email"
        label="Email address"
        type="email"
        autoComplete="email"
        errors={errors}
        register={register}
        rules={{
          required: "Email is required",
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Invalid email address",
          },
        }}
        testId="email"
      />
    </>
  );
};

export default NameAndEmail;
